import type { RouteObject } from 'react-router';

import * as orgDashboardGradFairsLinksHorizonRouteExports from '#/modules/orgDashboard/gradFairs/pages/links/OrgDashboardGradFairsLinks.horizon-route';
import * as orgDashboardAdminsLinksHorizonRouteExports from '#/modules/orgDashboard/pages/admins/links/OrgDashboardAdminsLinks.horizon-route';
import * as orgDashboardBuyCreditsLinksHorizonRouteExports from '#/modules/orgDashboard/pages/credits/buyLinks/OrgDashboardBuyCreditsLinks.horizon-route';
import * as orgDashboardCreditsLinksHorizonRouteExports from '#/modules/orgDashboard/pages/credits/links/OrgDashboardCreditsLinks.horizon-route';
import * as orgDashboardIntegrateAtsLinksHorizonRoute from '#/modules/orgDashboard/pages/integrations/atsLinks/OrgDashboardIntegrateAtsLinks.horizon-route';
import * as orgDashboardInvoicesLinksHorizonRouteExports from '#/modules/orgDashboard/pages/invoices/links/OrgDashboardInvoicesLinks.horizon-route';
import * as orgDashboardMembershipLinksHorizonRouteExports from '#/modules/orgDashboard/pages/membership/links/OrgDashboardMembershipLinks.horizon-route';
import * as orgDashboardEditOrgLinksHorizonRouteExports from '#/modules/orgDashboard/pages/orgs/editLinks/OrgDashboardEditOrgLinks.horizon-route';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

import {
  orgDashboardAdminsLinksRoute,
  orgDashboardBuyCreditsLinksRoute,
  orgDashboardCreditsLinksRoute,
  orgDashboardEditOrgLinksRoute,
  orgDashboardGradfairsLinksRoute,
  orgDashboardIntegrateAtsLinksRoute,
  orgDashboardInvoicesLinksRoute,
  orgDashboardMembershipLinksRoute,
} from './org-select.routes';

/**
 * A set of routes that use OrgDashboardOrgSelectionSubLayout
 *
 * These routes are separate in their own file to facilitate maintenance
 */
export const orgSelectRouteObjects = [
  {
    path: orgDashboardBuyCreditsLinksRoute.fullPath,
    ...horizonRouteToObject(orgDashboardBuyCreditsLinksHorizonRouteExports),
  },
  {
    path: orgDashboardCreditsLinksRoute.fullPath,
    ...horizonRouteToObject(orgDashboardCreditsLinksHorizonRouteExports),
  },
  {
    path: orgDashboardIntegrateAtsLinksRoute.fullPath,
    ...horizonRouteToObject(orgDashboardIntegrateAtsLinksHorizonRoute),
  },
  {
    path: orgDashboardAdminsLinksRoute.fullPath,
    ...horizonRouteToObject(orgDashboardAdminsLinksHorizonRouteExports),
  },
  {
    path: orgDashboardEditOrgLinksRoute.fullPath,
    ...horizonRouteToObject(orgDashboardEditOrgLinksHorizonRouteExports),
  },
  {
    path: orgDashboardGradfairsLinksRoute.fullPath,
    ...horizonRouteToObject(orgDashboardGradFairsLinksHorizonRouteExports),
  },
  {
    path: orgDashboardInvoicesLinksRoute.fullPath,
    ...horizonRouteToObject(orgDashboardInvoicesLinksHorizonRouteExports),
  },
  {
    path: orgDashboardMembershipLinksRoute.fullPath,
    ...horizonRouteToObject(orgDashboardMembershipLinksHorizonRouteExports),
  },
] satisfies RouteObject[];
